import React from 'react';

interface GlassCardProps {
  children: React.ReactNode;
  variant?: 'subtle' | 'medium' | 'strong';
  className?: string;
  hover?: boolean;
}

const variants = {
  subtle: 'bg-white/5 backdrop-blur-sm border-white/10',
  medium: 'bg-white/10 backdrop-blur-md border-white/20',
  strong: 'bg-white/20 backdrop-blur-lg border-white/30',
};

const hoverStyles = 'hover:bg-white/15 hover:border-white/30 hover:shadow-2xl hover:scale-[1.02] transition-all duration-300';

export const GlassCard: React.FC<GlassCardProps> = ({
  children,
  variant = 'medium',
  className = '',
  hover = false
}) => {
  return (
    <div
      className={`
        ${variants[variant]}
        border rounded-2xl p-6 shadow-xl
        dark:bg-white/5 dark:border-white/10
        ${hover ? hoverStyles : ''}
        ${className}
      `}
    >
      {children}
    </div>
  );
};

export default GlassCard;
